import { ElementSlider } from '../elements/element-slider'

let blockSlider = null
let sliderClass = '.related-posts .element-slider'
function initRelatedPostsSlider() {

  if(!$(sliderClass).length) return false

  blockSlider = new ElementSlider(sliderClass, false)

}

initRelatedPostsSlider()
